import React, {useEffect, useState} from 'react';
import {Button, ButtonGroup, Card, CardBody, CardHeader, CardTitle, Col, Row} from "reactstrap";
import classNames from "classnames";
import MapChart from "../../../../components/Chart/MapChart";

const MapReport = (props) => {
    const {chartdata,quarters, years} = props
    const [bigChartData, setBigChartData] = useState(null)
    const [chartData, setChartData] = useState(null)
    const [Quarters, setQuarters] = useState(null)

    const ChartData = (year) => {
        setBigChartData(year)
        const datas = chartdata.filter(y => y.year === year)
        const q = quarters.filter(y => y.year === year)
        setChartData(datas)
        setQuarters(q)
        
        console.log(year);
        console.log(datas);
    }
    useEffect(() => {
        ChartData(years[0])
    }, [])

    return (
        <Col xs="12">
            <Card className="card-chart">
                <CardHeader>
                    <Row>
                        <Col className="text-right" sm="6">
                            <h5 className="card-category">نقشه تفکیک استانی</h5>
                        </Col>
                        <Col sm="6">

                            <ButtonGroup
                                className="btn-group-toggle float-left"
                                data-toggle="buttons"
                            >
                                {
                                    years && years.sort().map((data, index) => (
                                        <Button
                                            key = {index}
                                            tag="label"
                                            className={classNames("btn-simple", {
                                                active: bigChartData === data,
                                            })}
                                            color="info"
                                            id={data}
                                            size="sm"
                                            onClick={() => ChartData(data)}
                                        >
                                            <span
                                                className="d-none d-sm-block d-md-block d-lg-block d-xl-block">{data}</span>
                                            <span className="d-block d-sm-none"><i
                                                className="tim-icons icon-single-02"/></span>
                                        </Button>
                                    ))
                                }

                            </ButtonGroup>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Row className={'width'}>
                        <div className=" h-100 ">
                            {chartData && <MapChart
                                chartdata={chartData[0]}
                                quarters={Quarters}
                            />}
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </Col>
    )
};

export default MapReport;